"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginIdentityFromToken = void 0;
const __1 = require("..");
const jwt_token_1 = require("./jwt_token");
const toolbox_1 = require("@streem/toolbox");
const LOGIN_IDENTITY_KEY = 'custom:streem_login_identity_id';
function getLoginIdentityFromToken(idToken) {
    const data = (0, jwt_token_1.parseJwtToken)(idToken);
    const loginIdentityId = data[LOGIN_IDENTITY_KEY];
    if (!loginIdentityId) {
        throw new __1.ForbiddenError(`Could not get login identity id from token for subject: '${data.sub}'`);
    }
    (0, toolbox_1.invariant)(data.email, 'idToken is expected to contain a user email');
    return {
        // rather than fetching access token from streem backend
        // accept the id from the FusionAuth provided token
        // platform endpoint will perform token validation
        id: loginIdentityId,
        avatarUrl: data.picture,
        name: data.name,
        email: data.email,
    };
}
exports.getLoginIdentityFromToken = getLoginIdentityFromToken;
//# sourceMappingURL=identified_user.js.map